import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoverImage, ExportCoverSheet } from '../../../models/export-cover-sheets';
import { ExportCoverSheetsService } from '../../../services/export-cover-sheets/export-cover-sheets.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { first, forkJoin, Observable, of } from 'rxjs';

@Component({
    selector: 'lib-new-cover-sheet-modal',
    templateUrl: './new-cover-sheet-modal.component.html',
    styleUrls: ['./new-cover-sheet-modal.component.css'],
    standalone: false
})
export class NewCoverSheetModalComponent implements OnInit {
  @ViewChild('coverImage') coverImage: ElementRef;

  isSubmitted: boolean;
  form: FormGroup;
  coverSheet: ExportCoverSheet;
  edit: ExportCoverSheet;

  constructor(
    public activeModal: NgbActiveModal,
    protected formBuilder: FormBuilder,
    protected exportCoverSheetsService: ExportCoverSheetsService
  ) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({
      category: this.formBuilder.control(this.edit?.category || '', [Validators.required])
    });
  }

  onCreate(id: string, inputFile, coverImage?) {
    const form = this.form.getRawValue();
    const additionalFiles: File[] = inputFile?.files || [];

    const coverImageUploadObservables: Observable<CoverImage>[] = [];
    let changeCover = false;
    if (coverImage) {
      const cover = this.coverImage.nativeElement.files[0];
      if (cover) {
        const formData = new FormData();
        formData.append('file', cover);
        formData.append('timeStamp', new Date().toISOString());
        changeCover = true;
        coverImageUploadObservables.push(this.exportCoverSheetsService.postCoverImageUpload(id, formData).pipe(first()));
      }
    }
    for (const file of additionalFiles) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('timeStamp', new Date().toISOString());
      coverImageUploadObservables.push(this.exportCoverSheetsService.postCoverImageUpload(id, formData).pipe(first()));
    }

    const uploadObservable =
      coverImageUploadObservables.length > 0 ? forkJoin(coverImageUploadObservables) : of([]);

    this.isSubmitted = true;
    uploadObservable.subscribe((images: CoverImage[]) => {
      if (this.edit) {
        if (!changeCover) {
          images.unshift(this.edit.image);
        }
        images = [...images, ...(this.edit.additionalImages || [])];
      }

      this.coverSheet = {
        id: this.edit ? this.edit.id : form.category + '_' + Date.now(),
        category: form.category,
        extra: this.edit?.extra ?? null,
        image: images.shift(),
        additionalImages: images.length > 0 ? Array.from(images) : [],
        index: this.edit?.index ?? null,
        name: this.edit?.name ?? null,
        season: this.edit?.season ?? ''
      };

      this.exportCoverSheetsService.putExportCoverSheet(this.coverSheet).subscribe(exportCoverSheet => {
        this.isSubmitted = false;
        this.activeModal.close(exportCoverSheet);
      });
    });
  }
}
